"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProfile = createProfile;
const fetchWrapper_1 = require("./fetchWrapper");
const baseUrls_1 = require("./baseUrls");
async function createProfile(formValues, authHeader, apiMethod) {
    let method = 'POST'; // Default method
    if (apiMethod.toUpperCase() === 'PATCH') {
        method = 'PATCH';
    }
    if (apiMethod.toUpperCase() === 'POST') {
        method = 'POST';
    }
    return (0, fetchWrapper_1.fetchWrapper)(`${baseUrls_1.UsersApiBaseUrl}/createProfile`, {
        method: method,
        headers: {
            Authorization: authHeader,
        },
        body: formValues, // Ensure to stringify the object
    });
}
